export const ABREV_PRODUTOS = {
  27: 'VR Benefícios',
  28: 'Auto',
  30: 'Cultura',
  31: 'Refeição',
  34: 'Cartão da Mamãe',
  51: 'Rede Compras',
};

export const NAME_BY_CODE = {
  27: 'VR Benefícios',
  28: 'Auto',
  30: 'Cultura',
  31: 'Refeição',
  51: 'Compras',
  50000: 'Banco VR',
};

export const NAME_BY_CODE_WITH_DECREE = {
  27: 'VR Benefícios',
  28: 'Auto',
  30: 'Cultura',
  31: 'Auxílio Refeição',
  51: 'Compras',
  268: 'Refeição (PAT)',
  269: 'Alimentação (PAT)',
  50000: 'Banco VR',
};

export const PAT_CODES_DECREE = new Set([268, 269]);

export const TRANSLATE_TO_VR_BENEFITS = new Set(['Alimentação','Auxílio Alimentação', 'Compras']);

export const PERIODOS = [
  {
    id: 0,
    value: '',
    label: 'Escolha o período',
  },
  {
    id: 1,
    value: '30',
    label: 'Últimos 30 dias',
  },
  {
    id: 2,
    value: '60',
    label: 'Últimos 60 dias',
  },
  {
    id: 3,
    value: '90',
    label: 'Últimos 90 dias',
  },
  {
    id: 4,
    value: '120',
    label: 'Últimos 120 dias',
  },
  {
    id: 5,
    value: '150',
    label: 'Últimos 150 dias',
  },
  {
    id: 6,
    value: '180',
    label: 'Últimos 180 dias',
  },
];

/**
 * @param 1 - vendas vr alimentacao
 * @param 3 - Taxa de Serviços
 * @param 11 - Tarifas Operacionais
 */
export const REEMBOLSO_DETAILS_COLORS = {
  1: 'positive',
  3: 'negative',
  11: 'negative',
};

export const ESTABLISHMENT_ACTIVATED = 'Establishment.activated';
export const ESTABLISHMENT_UPDATED = 'Establishment.updated';
export const ESTABLISHMENT_SELECTED = 'Establishment.selected';
export const ESTABLISHMENT_DATA_LOADED = 'Establishment.dataLoaded';

export const ESTABLISHMENT_SALES_PRINT = 'Establishment.salesPrint';
export const ESTABLISHMENT_REFUND_PRINT = 'Establishment.refundPrint';
export const PREVENT_LOGOUT_ON_ERROR_HEADER = "PREVENT_LOGOUT_ON_ERROR";
